import { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useCreateWorkspace } from '../lib/queries.js';

interface Props {
  open: boolean;
  onClose: () => void;
  redirectAfter?: boolean;
}

export function CreateWorkspaceModal({ open, onClose, redirectAfter = true }: Props) {
  const create = useCreateWorkspace();
  const nav = useNavigate();
  const [name, setName] = useState('');
  const [slug, setSlug] = useState('');
  const [error, setError] = useState<string | null>(null);

  if (!open) return null;

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    try {
      const ws = await create.mutateAsync({ name, slug });
      onClose();
      setName(''); setSlug('');
      if (redirectAfter) nav({ to: '/w/$slug', params: { slug: ws.slug } });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro');
    }
  }

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0,
        background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(8px)',
        display: 'grid', placeItems: 'center', zIndex: 300,
      }}
    >
      <form
        onClick={(e) => e.stopPropagation()}
        onSubmit={submit}
        className="glass-panel"
        style={{ borderRadius: 14, padding: 24, width: 420, maxWidth: '90vw' }}
      >
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 6 }}>Criar workspace</h2>
        <p style={{ color: 'var(--muted)', fontSize: 12, marginBottom: 16 }}>
          Workspaces agrupam grafos e membros. Você é owner por padrão.
        </p>
        <input
          required
          autoFocus
          value={name}
          onChange={(e) => {
            setName(e.target.value);
            if (!slug) setSlug(e.target.value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''));
          }}
          placeholder="Nome do workspace"
          style={inputStyle}
        />
        <input
          required
          value={slug}
          onChange={(e) => setSlug(e.target.value)}
          pattern="[a-z0-9]+(-[a-z0-9]+)*"
          placeholder="slug (kebab-case)"
          style={{ ...inputStyle, fontFamily: 'var(--font-mono)', fontSize: 12 }}
        />
        {error && <div style={{ color: '#f87171', fontSize: 12, marginTop: 6 }}>{error}</div>}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
          <button type="button" onClick={onClose} style={cancelBtn}>Cancelar</button>
          <button type="submit" disabled={create.isPending} style={primaryBtn}>
            {create.isPending ? 'criando…' : 'Criar'}
          </button>
        </div>
      </form>
    </div>
  );
}

const inputStyle: React.CSSProperties = {
  width: '100%', marginTop: 8,
  background: 'rgba(255,255,255,0.04)',
  border: '1px solid var(--border)',
  borderRadius: 8, padding: '10px 12px',
  color: 'var(--text)', fontSize: 13, outline: 'none',
};
const primaryBtn: React.CSSProperties = {
  background: 'var(--neon)', color: '#0a0a0f', border: 'none',
  borderRadius: 8, padding: '8px 16px', fontWeight: 600, fontSize: 13, cursor: 'pointer',
};
const cancelBtn: React.CSSProperties = {
  background: 'transparent', color: 'var(--muted)', border: 'none',
  padding: '8px 12px', fontSize: 13, cursor: 'pointer',
};
